import React from "react";
import Navbar from "./componentes/Navbar";
import Hero from "./componentes/Hero";
import SobreMi from "./componentes/SobreMi";
import Tecnologías from "./componentes/Tecnologias";
import Experiencias from "./componentes/Experiencias";
import Proyectos from "./componentes/Proyectos";
import Contacto from "./componentes/Contacto";
import Footer from "./componentes/Footer";

const App = () => {
  return (
    <div className="min-h-screen overflow-x-hidden bg-[radial-gradient(ellipse_at_top,rgba(255,255,255,0.12)_0%,transparent_55%),radial-gradient(ellipse_at_bottom,rgba(47,89,114,0.15)_0%,transparent_60%),linear-gradient(135deg,#f5f7fa_0%,#e9eef2_25%,#dfe7ec_45%,#eef2f5_65%,#d8e1e7_100%)] bg-fixed font-sans text-[#1c2143] antialiased selection:bg-[#1c2143] selection:text-white">
      <Navbar />

      <main className="relative">
        <Hero />
        <SobreMi />
        <Tecnologías />
        <Experiencias />
        <Proyectos />
        <Contacto />
      </main>

      <Footer />
    </div>
  );
};

export default App;